import { makeStyles, createStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    audioPlayer: {
      textAlign: 'center',
      width: '100%',
    },
  }),
);
